module.exports = __webpack_public_path__ + "img/motorway_10x2_z16.da0b2e49.svg";